import axios from 'axios'

// Branches are read-only in the app (maintained directly in the database),
// so this module only knows how to load the list.
export default {
  list (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/branch')
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
